import { toast } from "react-toastify";
import API_URL from "../config/config";
// Reusable function to verify token on load
export const verifyToken = async (setShowSessionExpiredPopup) => {
  const token = localStorage.getItem("token");
  if (!token) return true; // No token, valid for public pages

  try {
    const response = await fetch(`${API_URL}/user`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (response.status === 200) {
      return true;
    } else {
      let errorMessage = "An error occurred. Please try again.";
      try {
        const responseData = await response.json();
        errorMessage = responseData.message || errorMessage;

        if (
          response.status === 401 ||
          errorMessage.toLowerCase().includes("session expired") ||
          errorMessage.toLowerCase().includes("invalid token")
        ) {
          setShowSessionExpiredPopup(true);
        } else {
          toast.error(errorMessage, { position: "bottom-center" });
        }
      } catch (jsonError) {
        toast.error(errorMessage, { position: "bottom-center" });
      }
      return false;
    }
  } catch (error) {
    console.error("Token verification failed:", error);
    let errorMessage = "An error occurred. Please try again.";
    if (error.name === "TypeError" && error.message.includes("Failed to fetch")) {
      errorMessage = "Could not reach the server. Please check your internet connection.";
    }
    toast.error(errorMessage, { position: "bottom-center" });
    // Optionally: setShowSessionExpiredPopup(true);
    return false;
  }
};

// Reusable function to check token validity and navigate
export const checkTokenAndNavigate = (
  destination,
  navigate,
  setShowSigninModal,
  setShowSessionExpiredPopup,
  closeMenu = () => {},
  e
) => {
  const token = localStorage.getItem("token");
  const requiresAuth =
    destination === "/orders" ||
    destination === "/create-order" ||
    destination === "/wallet";

  if (!requiresAuth) {
    navigate(destination);
    closeMenu();
    return;
  }

  if (!token) {
    e?.preventDefault?.();
    setShowSigninModal(true);
    closeMenu();
    return;
  }

  navigate(destination);
  closeMenu();
};
